import {
  Component,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  Injector,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';
import { DateManagerService } from '@core/services/date-manager/date-manager.service';
import { AbstractDateTimeInputComponent } from '../abstract-datetime.component';

@Component({
  selector: 'xpw-form-input-date',
  template: `
    <nz-form-item>
      <nz-form-label
        >{{ label }} {{ isOptional ? ' (Optional)' : '' }}
      </nz-form-label>
      <nz-form-control
        [nzHasFeedback]="true"
        [nzValidateStatus]="errorStatus()"
        [nzErrorTip]="getErrorLabel()"
      >
        <nz-date-picker
          ngDefaultControl
          [nzFormat]="dateFormat"
          [(ngModel)]="value"
          (ngModelChange)="calanderChange($event)"
          [nzDisabled]="readonly"
          [nzDisabledDate]="disabledDate"
          (blur)="onTouched()"
        ></nz-date-picker>
        <ng-content></ng-content>
      </nz-form-control>
    </nz-form-item>
  `,
  styleUrls: ['./xpw-form-input-date.component.less'],

  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => XpwFormInputDateComponent),
      multi: true,
    },
  ],
})
export class XpwFormInputDateComponent extends AbstractDateTimeInputComponent {
  @Input('label') label: string;
  @Input() showDateTime: boolean = false;
  @Input() minDate: Date = null;
  @Input() maxDate: Date = null;
  @Input() allowFutureDate: boolean = true;
  dateFormat: string;
  constructor(
    private dateService: DateManagerService,
    injector: Injector,
  ) {
    super(injector);
    this.dateFormat = this.format;
  }
  private today = this.dateService.getOnlyDate(new Date());

  get format(): string {
    console.log(' get format()', this.dateService.dateTimePickerFormat);
    if (this.showDateTime) {
      return this.dateService.DateTimePickerFormat;
    } else {
      return this.dateService.DatePickerFormat;
    }
  }

  calanderChange = (value: any): void => {
    this.onChange(this.dateService.getOnlyDate(value));
  };

  // Can not select days before today and today
  disabledDate = (current: Date): boolean => {
    return (
      (this.maxDate && current > this.maxDate) ||
      (this.minDate && current < this.minDate) ||
      (!this.allowFutureDate && current > this.today)
    );
  };
}
